export function resolveStartUrl(
    envUrl?: string,
    location: Pick<Location, "protocol" | "hostname"> = window.location,
): string | undefined {
    const configured = envUrl?.trim();
    if (configured) {
        return configured.replace(/\/$/, "");
    }

    if (location.hostname.startsWith("portal.")) {
        return `${location.protocol}//start.${location.hostname.slice("portal.".length)}`;
    }

    return undefined;
}

/**
 * /me succeeds for any authenticated user. Portal pages need an employee
 * with an establishment. Users without that (CRM-only, no LMS access)
 * would otherwise sit on the loader forever.
 */
export function meCannotEnterPortal(
    me?: {
        id?: number | null;
        establishment?: unknown;
    } | null,
): boolean {
    if (!me) {
        return false;
    }

    return me.id == null || me.establishment == null;
}
